/** CDN base URL for static assets (CSS, JS, fonts). Empty string when not configured. */
export function getCdnUrl(): string {
	return import.meta.env.DEV ? '' : (import.meta.env.VITE_CDN_URL ?? '');
}

/** imgproxy base URL for image transformation. */
export function getImgproxyUrl(): string | undefined {
	return import.meta.env.VITE_IMGPROXY_URL;
}
